import {ColumnLayout, ExpandableSection} from '@amzn/awsui-components-react'
import React, {useEffect, useState} from 'react'
import {RouteComponentProps, withRouter} from 'react-router-dom'
import {Iog} from '../../backend/model'
import LabelledValue from '../basic/LabeledValue'
import {convertKeyToLabel} from '../search/SearchUtils'

interface IogSummaryPanelProps extends RouteComponentProps {
    iog: Iog;
}

const IogSummaryPanel: React.FC<IogSummaryPanelProps> = (props) => {
    const [iog, setIog] = useState(props.iog)

    useEffect(() => {
            setIog(props.iog)
        }, [props.iog],
    )

    const renderSummary = () => {
        const iogMetadata = iog.iogMetadata.length > 0 ? iog.iogMetadata[0].matchedMetadata : null
        const columnCount = 1 + (iogMetadata?.length || 0)

        return (
            <ColumnLayout columns={columnCount} minColumnWidth={150} variant="text-grid">
                <LabelledValue id="iogSummaryPanel-iogName" label="Name">{iog.iogName}</LabelledValue>
                {iogMetadata?.map((metadata) => (
                    <LabelledValue key={metadata.key} id={`iogSummaryPanel-${metadata.key}`} label={convertKeyToLabel(metadata.key)}>
                        {metadata.value}
                    </LabelledValue>
                ))}
            </ColumnLayout>
        )
    }

    return (
        <ExpandableSection
            id="iogSummaryPanel"
            variant="container"
            headerText="Summary"
            children={renderSummary()}
            defaultExpanded/>
    )
}

export default withRouter(IogSummaryPanel)
